module.exports = __webpack_public_path__ + "static/media/EquipmentSpecialist.6c241756.jpg";